import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { FormItemType } from '../Standings/HelperClass/FormItem'
import { TestID } from '../../utils/PropTypesDefinitions'
import HorizontalFormLine from './HelperClass/HorizontalFormLine'
import VerticalFormMatch from './HelperClass/VerticalFormMatch'
import RectangleLine from './HelperClass/RectangleLine'

export type FormProps = {
    /**
     * imageUrl of the competition
     */
    competitionImageUrl?: string
    /** info about competitionImageUrl for seo */
    competitionImageAlt?: string
    /**
     * imageUrl of the competitor
     */
    competitorImageUrl?: string
    /** info about competitorImageUrl for seo */
    competitorImageAlt?: string
    /**
     * result in points / goals of the match
     */
    result: string
    /**
     * result as a string ('WIN', 'DRAW', 'LOST')
     */
    form: FormItemType
}

export type TeamFormProps = {
    /**
     * array of forms
     */
    forms: FormProps[]
    /**
     * action called when pressed on the competitor / result
     * @TJS-type: function
     */
    onPressMatch?: (index: number) => void
    /**
     * action called when pressed on the competition
     * @TJS-type: function
     */
    onPressCompetition?: (index: number) => void
} & TestID

const TeamForm: FunctionComponent<TeamFormProps> = ({
    forms,
    onPressMatch,
    onPressCompetition,
    testID,
}) => {
    if (!forms.length) {
        return null
    }
    return (
        <Grid backgroundColor="pearl" zIndex={-1} position="relative" horizontal testID={testID}>
            <Grid position="absolute" horizontal left={55} right={31}>
                {forms.map((value, index) => {
                    if (index < forms.length - 1) {
                        const nextForm = forms[index + 1].form
                        return (
                            <RectangleLine
                                key={`rect-line-${index}-${value.form}-${nextForm}`}
                                currentForm={value.form}
                                nextForm={nextForm}
                            />
                        )
                    }
                    return null
                })}
            </Grid>
            <Grid horizontal paddingLeft={40} paddingRight={5}>
                {forms.map((value, index) => {
                    const match = (
                        <VerticalFormMatch
                            key={`team-form-${index}'`}
                            result={value.result}
                            form={value.form}
                            competitorImageUrl={value.competitorImageUrl}
                            competitorImageAlt={value.competitorImageAlt}
                            competitionImageUrl={value.competitionImageUrl}
                            competitionImageAlt={value.competitionImageAlt}
                            onPressMatch={
                                onPressMatch ? (): void => onPressMatch(index) : undefined
                            }
                            onPressCompetition={
                                onPressCompetition
                                    ? (): void => onPressCompetition(index)
                                    : undefined
                            }
                        />
                    )
                    if (!(index < forms.length - 1)) {
                        return match
                    }
                    return (
                        <Grid key={`team-form-${index}-grid'`} horizontal>
                            {match}
                            <Grid />
                        </Grid>
                    )
                })}
            </Grid>
            <Grid position="absolute" top={24} width="100%" zIndex={-1}>
                <HorizontalFormLine type="S" />
                <HorizontalFormLine type="U" />
                <HorizontalFormLine type="N" />
            </Grid>
        </Grid>
    )
}
export default TeamForm
